// local state
const getDefaultState = () => {
  return {
    user: {
      registration_complete: false,
      auth: false,
      email: '',
      first_name: '',
      last_name: '',
      countries_id: '',
      articles: [],
      company_name: '',
      street: '',
      post_code: '',
      city: '',
      company_phone: '',
      company_mobile: '',
      company_fax: '',
    },
    country: {
      language_code: 'de',
      language_id: 1,
      country_code: 'de',
      country_id: 276,
    },
    session: null,
    needLogin: false,
    projectData: [],
    persistedstatate: 0,
    configuration: false,
  }
};

const state = getDefaultState()

const getters = {};

const mutations = {
  persisdateData(state) {
    state.persistedstatate++
  },
  updateUser(state, user) {
    state.user = user
  },
  updateCountry(state, country) {
    state.country = country
  },
  updateSession(state, session) {
    state.session = session
  },
  updateNeedLogin(state, session) {
    state.needLogin = session
  },
  updateProjectData(state, projectData) {
    state.projectData = projectData
  },
  updateConfiguration(state, configuration) {
    state.configuration = configuration
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
};

const actions = {
  resetState({commit}) {
    commit('resetState')
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
